import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'blocks_feedback'

export default function BlocksFeedbackPage() {
  const submit = useSubmit()
  const { isUpdate, postToReactNative } = useUpdateMode()
  const { t } = useTranslation()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'Blocks feedback shown',
      answer_key: 'acknowledged',
      answer: 'acknowledged',
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget, { method: 'post' })
    }
  }

  return (
    <FeedbackPage
      emoji="💪"
      heading={t('pages.onboarding.blocksFeedback.heading')}
      text={t('pages.onboarding.blocksFeedback.text')}
      onSubmit={onSubmit}
    />
  )
}
